import { theme } from "../../theme";
import { StyleSheet, Platform } from "react-native";
export const styles = StyleSheet.create({
    defaults: {
        paddingVertical: theme.spacing.xsmall,
        paddingHorizontal: theme.spacing.small,
    },
    text: Platform.select({
        web: {
            whiteSpace: "noWrap",
            textTransform: "uppercase",
        },
        default: {
            textTransform: "uppercase",
        },
    }),
    brand: {
        backgroundColor: theme.colors.brand.base,
        color: theme.colors.light.base,
    },
    positive: {
        backgroundColor: theme.colors.positive.base,
        color: theme.colors.light.base,
    },
    accent: {
        backgroundColor: theme.colors.accent.base,
        color: theme.colors.dark.base,
    },
    negative: {
        backgroundColor: theme.colors.negative.base,
        color: theme.colors.light.base,
    },
    greyscale: {
        backgroundColor: theme.colors.greyscale.base,
        color: theme.colors.light.base,
    },
    warning: {
        backgroundColor: theme.colors.warning.base,
        color: theme.colors.dark.base,
    },
    usp: {
        backgroundColor: theme.colors.usp.base,
        color: theme.colors.light.base,
    },
    medium: {
        ...theme.fontDefaults.xsmall,
        borderRadius: theme.spacing.xlarge,
    },
    small: {
        ...theme.fontDefaults.xsmall2,
        borderRadius: theme.spacing.small,
    },
});
//# sourceMappingURL=Pill.styles.js.map